/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetSubscriptionUsage200ResponseIntegratedTabs } from './GetSubscriptionUsage200ResponseIntegratedTabs';
import {
    GetSubscriptionUsage200ResponseIntegratedTabsFromJSON,
    GetSubscriptionUsage200ResponseIntegratedTabsFromJSONTyped,
    GetSubscriptionUsage200ResponseIntegratedTabsToJSON,
    GetSubscriptionUsage200ResponseIntegratedTabsToJSONTyped,
} from './GetSubscriptionUsage200ResponseIntegratedTabs';
import type { GetSubscriptionUsage200ResponseDevices } from './GetSubscriptionUsage200ResponseDevices';
import {
    GetSubscriptionUsage200ResponseDevicesFromJSON,
    GetSubscriptionUsage200ResponseDevicesFromJSONTyped,
    GetSubscriptionUsage200ResponseDevicesToJSON,
    GetSubscriptionUsage200ResponseDevicesToJSONTyped,
} from './GetSubscriptionUsage200ResponseDevices';
import type { GetSubscriptionUsage200ResponseSmsSent } from './GetSubscriptionUsage200ResponseSmsSent';
import {
    GetSubscriptionUsage200ResponseSmsSentFromJSON,
    GetSubscriptionUsage200ResponseSmsSentFromJSONTyped,
    GetSubscriptionUsage200ResponseSmsSentToJSON,
    GetSubscriptionUsage200ResponseSmsSentToJSONTyped,
} from './GetSubscriptionUsage200ResponseSmsSent';

/**
 * 
 * @export
 * @interface GetSubscriptionUsage200Response
 */
export interface GetSubscriptionUsage200Response {
    /**
     * 
     * @type {GetSubscriptionUsage200ResponseDevices}
     * @memberof GetSubscriptionUsage200Response
     */
    devices: GetSubscriptionUsage200ResponseDevices;
    /**
     * 
     * @type {GetSubscriptionUsage200ResponseDevices}
     * @memberof GetSubscriptionUsage200Response
     */
    integrations: GetSubscriptionUsage200ResponseDevices;
    /**
     * 
     * @type {GetSubscriptionUsage200ResponseIntegratedTabs}
     * @memberof GetSubscriptionUsage200Response
     */
    integratedTabs: GetSubscriptionUsage200ResponseIntegratedTabs;
    /**
     * 
     * @type {GetSubscriptionUsage200ResponseSmsSent}
     * @memberof GetSubscriptionUsage200Response
     */
    smsSent: GetSubscriptionUsage200ResponseSmsSent;
}

/**
 * Check if a given object implements the GetSubscriptionUsage200Response interface.
 */
export function instanceOfGetSubscriptionUsage200Response(value: object): value is GetSubscriptionUsage200Response {
    if (!('devices' in value) || value['devices'] === undefined) return false;
    if (!('integrations' in value) || value['integrations'] === undefined) return false;
    if (!('integratedTabs' in value) || value['integratedTabs'] === undefined) return false;
    if (!('smsSent' in value) || value['smsSent'] === undefined) return false;
    return true;
}

export function GetSubscriptionUsage200ResponseFromJSON(json: any): GetSubscriptionUsage200Response {
    return GetSubscriptionUsage200ResponseFromJSONTyped(json, false);
}

export function GetSubscriptionUsage200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSubscriptionUsage200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'devices': GetSubscriptionUsage200ResponseDevicesFromJSON(json['devices']),
        'integrations': GetSubscriptionUsage200ResponseDevicesFromJSON(json['integrations']),
        'integratedTabs': GetSubscriptionUsage200ResponseIntegratedTabsFromJSON(json['integratedTabs']),
        'smsSent': GetSubscriptionUsage200ResponseSmsSentFromJSON(json['smsSent']),
    };
}

export function GetSubscriptionUsage200ResponseToJSON(json: any): GetSubscriptionUsage200Response {
    return GetSubscriptionUsage200ResponseToJSONTyped(json, false);
}

export function GetSubscriptionUsage200ResponseToJSONTyped(value?: GetSubscriptionUsage200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'devices': GetSubscriptionUsage200ResponseDevicesToJSON(value['devices']),
        'integrations': GetSubscriptionUsage200ResponseDevicesToJSON(value['integrations']),
        'integratedTabs': GetSubscriptionUsage200ResponseIntegratedTabsToJSON(value['integratedTabs']),
        'smsSent': GetSubscriptionUsage200ResponseSmsSentToJSON(value['smsSent']),
    };
}

